(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  var viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    var value = window.outerWidth > 375 ? 'width=device-width,initial-scale=1' : 'width=360';
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  }
  addEventListener('resize', switchViewport, false);
  switchViewport();
  var nav = $('#menu-sp'),
    mobileNav = $('#nav-header'),
    navItems = {
      1: nav,
      2: mobileNav
    };
  nav.on('click', function (e) {
    e.preventDefault();
    if (!nav.hasClass('js-active')) {
      $.each(navItems, function (index, element) {
        element.addClass('js-active');
      });
    } else {
      $.each(navItems, function (index, element) {
        element.removeClass('js-active');
      });
    }
  });

  //Sticky header scroll
  var header_menu_scroll = function header_menu_scroll() {
    $('.menu-item > a[href^="#"]').click(function () {
      var speed = 500;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      if (window.innerWidth < 768) {
        var position = target.offset().top - 33;
      } else if (768 <= window.innerWidth && window.innerWidth < 922) {
        var position = target.offset().top - 56;
      } else {
        var position = target.offset().top - 49;
      }
      $("html, body").animate({
        scrollTop: position
      }, speed, "swing");
      if (nav.hasClass('js-active')) {
        $.each(navItems, function (index, element) {
          element.removeClass('js-active');
        });
      }
      return false;
    });
  };
  $(window).on('load', header_menu_scroll);
  var header = $('.header-v3'),
    show = $('#section-case').offset().top;
  var show_header = function show_header() {
    var windowTop = $(window).scrollTop();
    if (window.innerWidth < 768) {
      if (windowTop < show) {
        header.removeClass('js-active');
      } else {
        header.addClass('js-active');
      }
    }
  }; //show_header function
  $(window).on('scroll', show_header);

  // Sticky CTA
  var fix = $('#js-fixed-cta'),
    show = $('#section-case').offset().top,
    hide = $('#section-contact').offset().top;
  var show_fixed_cta = function show_fixed_cta() {
    var fixed_top = $('#js-fixed-cta').offset().top;
    if (fixed_top < show) {
      fix.removeClass('js-active');
    } else if (show <= fixed_top && fixed_top < hide) {
      fix.addClass('js-active');
    } else {
      fix.removeClass('js-active');
    }
  }; //show_fixed_cta function
  $(window).on('scroll', show_fixed_cta);
})(jQuery); // Fully reference jQuery after this point.

},{}]},{},[1]);
